export const ExamenEntity = {
    id: null,
    titulo: '',
    descripcion: '',
    puntosMaximos: '',
    numeroDePreguntas: '',
    activo: false,
    curso: {
        id: null,
        codigo: '',
        titulo: '',
    }
};